export const getAllObjectDescription = 'GET_ALL_OBJ_DESCRIPTION';

const INITIAL_STATE = {
    objDesc: [],
};

const ACTION_HANDLERS = {
    [getAllObjectDescription]: (state, payload) => ({
        ...state,
        objDesc: payload,
    }),
};

export default (state = INITIAL_STATE, { type, payload }) => {
    const fn = ACTION_HANDLERS[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};
